
const { ccclass, property } = cc._decorator;


@ccclass
export default class EditorBoxCenter extends cc.Component {

    @property(cc.EditBox)
    editorBox: cc.EditBox = null

    @property()
    charWidth: number = 25

    @property()
    bgWidth: number = 319

    @property()
    resetX: number = 0//用于默认提示文字的宽度

    setString(str: string) {
        this.editorBox.string = str
        this.onTextChange()
    }

    private onTextChange() {
        let size: cc.Size = this.editorBox.node.getContentSize()
        if (this.editorBox.string.length == 0) {
            size.width = this.bgWidth
            if (this.resetX > 0) {
                size.width = this.resetX
            }
        } else {
            size.width = this.charWidth * this.editorBox.string.length
        }
        this.editorBox.node.setContentSize(size)
    }


}